<template>
  <div>
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 v-if="tourismType === 1" class="profile-section-title"><i class="ni ni-align-center"></i> پارک دلفین </h4>
      <h4 v-if="tourismType === 2" class="profile-section-title"><i class="ni ni-align-center"></i>  فست ترک </h4>
    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
          <div class="content-current-profile">
            <main v-if="tourismType === 2">
              <div>
                <div id="tabs" class="tabs">
                  <nav>
                    <ul>
                      <li title="ویرایش اطلاعات فست ترک" class="icon-booking" :class="{ 'tab-current': tabIndex == 0 }"
                        @click="tabIndex = 0">
                        <a class="icon-edit">
                          <span> ویرایش اطلاعات </span>
                        </a>
                      </li>
                      <li title="کنسلی رزرو فست ترک" class="icon-booking" :class="{ 'tab-current': tabIndex == 1 }"
                        @click="tabIndex = 1">
                        <a class="icon-cancel">
                          <span> کنسلی رزرو </span>
                        </a>
                      </li>
                      <li title="افزایش اعتبار" class="icon-booking" :class="{ 'tab-current': tabIndex == 2 }"
                        @click="tabIndex = 2">
                        <a class="icon-money-2">
                          <span> افزایش اعتبار</span>
                        </a>
                      </li>
                      <li title="گزارش تراکنش اعتبار" class :class="{ 'tab-current': tabIndex == 3 }"
                        @click="tabIndex = 3">
                        <a class="icon-confirmed-report">
                          <span> گزارش تراکنش اعتبار </span>
                        </a>
                      </li>
                    </ul>
                  </nav>

                  <div class="content">
                    <FastTrackEditInfo v-if="tabIndex == 0" />
                    <TourismCancelReservation v-if="tabIndex == 1" />

                    <tourism-increase v-if="tabIndex == 2" />
                    <TourismDepositReport v-if="tabIndex == 3" />
                  </div>
                </div>
                <!-- End tabs -->
              </div>
            </main>

            <main v-if="tourismType === 1">
              <div>
                <div id="tabs" class="tabs">
                  <nav>
                    <ul>
                      <li title="ویرایش اطلاعات دلفین" class="icon-booking" :class="{ 'tab-current': tabIndex == 0 }"
                        @click="tabIndex = 0">
                        <a class="icon-edit">
                          <span> ویرایش اطلاعات </span>
                        </a>
                      </li>
                      <li title="کنسلی رزرو دلفین" class="icon-booking" :class="{ 'tab-current': tabIndex == 1 }"
                        @click="tabIndex = 1">
                        <a class="icon-cancel">
                          <span> کنسلی رزرو </span>
                        </a>
                      </li>
                      <li title="افزایش اعتبار" class="icon-booking" :class="{ 'tab-current': tabIndex == 2 }"
                        @click="tabIndex = 2">
                        <a class="icon-money-2">
                          <span> افزایش اعتبار </span>
                        </a>
                      </li>
                      <li title="گزارش تراکنش اعتبار دلفین" class :class="{ 'tab-current': tabIndex == 3 }"
                        @click="tabIndex = 3">
                        <a class="icon-confirmed-report">
                          <span> گزارش تراکنش اعتبار </span>
                        </a>
                      </li>
                    </ul>
                  </nav>

                  <div class="content" >
                    <DolphinEditInfo v-if="tabIndex == 0" />
                    <TourismCancelReservation v-if="tabIndex == 1" />

                    <tourism-increase v-if="tabIndex == 2" />
                    <TourismDepositReport v-if="tabIndex == 3" />
                  </div>
                </div>
                <!-- End tabs -->
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TourismIncrease from "@/components/profile/tourism/TourismIncrease.vue";
import TourismDepositReport from "@/components/profile/tourism/TourismDepositReport.vue";
import TourismCancelReservation from "@/components/profile/tourism/TourismCancelReservation.vue";
import FastTrackEditInfo from "@/components/profile/tourism/FastTrackEditInfo.vue";
import DolphinEditInfo from "@/components/profile/tourism/DolphinEditInfo.vue";

export default {
  name: "ProfileContent",
  components: {
    TourismIncrease,
    TourismDepositReport,
    TourismCancelReservation,
    FastTrackEditInfo,
    DolphinEditInfo,
  },
  data: function () {
    return {
      tabIndex: 0,
      tourismType: 1,
    };
  },
  watch: {
    "$route.params.tourismType": {
      handler: function (tourismType) {
        if (tourismType === "fastTrack") this.tourismType = 2;
        else this.tourismType = 1;
        this.tabIndex = 0;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style>
.content{
  background: #fff;
}
</style>

